import { Component, Input, OnInit } from "@angular/core";
import { TargetChartPopupViewModel } from "./target-details-popup.view-model";

@Component({
  selector: "evrideo-channel-input-details-popup",
  templateUrl: "./target-details-popup.component.html",
  styleUrls: ["./target-details-popup.component.scss"],
})
export class TargetDetailsPopupComponent implements OnInit {
  @Input()
  public vm: TargetChartPopupViewModel;
  constructor() {}

  ngOnInit(): void {}
}
